export let options = [{
		label: '流行购物中心',
		options: [{
				value: '箱包皮具',
				label: '箱包皮具'
			}, {
				value: '化妆品护理',
				label: '化妆品护理'
			},
			{
				value: '花饰',
				label: '花饰'
			},
			{
				value: '珠宝配饰',
				label: '珠宝配饰'
			},
			{
				value: '儿童系列',
				label: '儿童系列'
			},
			{
				value: '文化体育用品',
				label: '文化体育用品'
			},
			{
				value: '鞋帽手套',
				label: '鞋帽手套'
			},
			{
				value: '男装',
				label: '男装'
			},
			{
				value: '女装',
				label: '女装'
			}
		]

	}, {
		label: '餐饮',
		options: [{
				value: '大型餐饮',
				label: '大型餐饮'
			}, {
				value: '主题餐饮',
				label: '主题餐饮'
			},
			{
				value: '西式餐饮',
				label: '西式餐饮'
			},
			{
				value: '料理店',
				label: '料理店'
			},
			{
				value: '连锁快餐',
				label: '连锁快餐'
			},
			{
				value: '火锅店',
				label: '火锅店'
			},
			{
				value: '休闲餐饮',
				label: '休闲餐饮'
			},
			{
				value: '咖啡厅',
				label: '咖啡厅'
			},
			{
				value: '面馆',
				label: '面馆'
			},
			{
				value: '茶坊',
				label: '茶坊'
			},
			{
				value: '酒吧',
				label: '酒吧'
			},
			{
				value: '甜品',
				label: '甜品'
			},
			{
				value: '水吧、奶茶',
				label: '水吧、奶茶'
			}
		],

	},
	{
		label: "休闲娱乐",
		options: [{
				value: "电影院",
				label: "电影院"
			},
			{
				value: "动漫城",
				label: "动漫城"
			},
			{
				value: "俱乐部",
				label: "俱乐部"
			},
			{
				value: "夜总会",
				label: "夜总会"
			},
			{
				value: "桑拿浴场",
				label: "桑拿浴场"
			},
			{
				value: "儿童乐园",
				label: "儿童乐园"
			},
			{
				value: "迪厅",
				label: "迪厅"
			},
			{
				value: "KTV酒吧",
				label: "KTV酒吧"
			},
			{
				value: "健身房",
				label: "健身房"
			},
			{
				value: "电玩城",
				label: "电玩城"
			},
			{
				value: "溜冰场",
				label: "溜冰场"
			},
			{
				value: "台球吧",
				label: "台球吧"
			},
			{
				value: "网吧",
				label: "网吧"
			},
		],
	},
	{
		label: "大型卖场",
		options: [{
				value: "家居",
				label: "家居"
			},
			{
				value: "建材广场",
				label: "建材广场"
			},
			{
				value: "大型购物广场",
				label: "大型购物广场"
			},
			{
				value: "家电广场",
				label: "家电广场"
			},
			{
				value: "数码城",
				label: "数码城"
			}
		],
	},
	{
		label: "时尚生活中心",
		options: [{
				value: "美容美发点",
				label: "美容美发点"
			},
			{
				value: "养生保健店",
				label: "养生保健店"
			},
			{
				value: "礼品/精品",
				label: "礼品/精品"
			},
			{
				value: "工艺品",
				label: "工艺品"
			},
			{
				value: "眼镜",
				label: "眼镜"
			},
			{
				value: "钟表店",
				label: "钟表店"
			},
			{
				value: "书店",
				label: "书店"
			},
			{
				value: "音像店",
				label: "音像店"
			},
			{
				value: "烟酒店",
				label: "烟酒店"
			},
			{
				value: "家居饰品店",
				label: "家居饰品店"
			},
			{
				value: "汽车",
				label: "汽车"
			},
			{
				value: "配套服务",
				label: "配套服务"
			}
		],
	}
]
